"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var platformCardApi = _interopRequireWildcard(require("@/api/platformCardApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      loading: false,
      productLists: [],
      form: {},
      rules: {
        skuId: [{
          required: true,
          message: '请选择对应商品',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit() {
      var _this = this;
      this.form = {
        remark: ''
      };
      this.visible = true;
      this.searchProduct('');
      this.$nextTick(function () {
        return _this.$refs.form && _this.$refs.form.clearValidate();
      });
    },
    searchProduct: function searchProduct() {
      var _this2 = this;
      var skuName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      platformCardApi.getProductSkuList({
        type: 0,
        productType: 12,
        page: 1,
        limit: 50,
        skuName: skuName
      }).then(function (res) {
        _this2.productLists = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
    },
    handleProductSearch: function handleProductSearch(value) {
      var _this3 = this;
      this.throttle(function () {
        return _this3.searchProduct(value);
      }, 300)();
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this4.loading = true;
        platformCardApi.saveCardConfig({
          skuId: _this4.form.skuId,
          remark: _this4.form.remark
        }).then(function () {
          _this4.$message.success('操作成功');
          _this4.visible = false;
          _this4.$emit('doRefresh');
        }).finally(function () {
          _this4.loading = false;
        });
      });
    }
  }
};